import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import axios from "axios";
import Loading from "./Loading";
import { Helmet } from "react-helmet-async";
const MoviePage = () => {
  const API_KEY = "5cb3971f2ed6c001df1ae772ee291eb2";
  const { id } = useParams();
  const [movie, setMovie] = useState(null);
  const [cast, setCast] = useState([]);
  const [trailer, setTrailer] = useState("");
  const [imdbId, setImdbId] = useState("");
  const navigate = useNavigate();
  const [recommendations, setRecommendations] = useState([]);

  useEffect(() => {
    fetch(
      `https://api.themoviedb.org/3/movie/${id}/recommendations?api_key=${API_KEY}`
    )
      .then((res) => res.json())
      .then((data) => {
        setRecommendations(data.results || []);
      })
      .catch((error) => console.log(error));
  }, [id]);
  console.log(recommendations);
  useEffect(() => {
    const fetchMovie = async () => {
      try {
        const [details, credits, videos, externalIds] = await Promise.all([
          axios.get(
            `https://api.themoviedb.org/3/movie/${id}?api_key=${API_KEY}`
          ),

          axios.get(
            `https://api.themoviedb.org/3/movie/${id}/credits?api_key=${API_KEY}`
          ),

          axios.get(
            `https://api.themoviedb.org/3/movie/${id}/videos?api_key=${API_KEY}`
          ),

          axios.get(
            `https://api.themoviedb.org/3/movie/${id}/external_ids?api_key=${API_KEY}`
          ),
        ]);

        setMovie(details.data);

        setCast(credits.data.cast.slice(0, 10));

        setImdbId(externalIds.data.imdb_id);

        const trailerVideo = videos.data.results.find(
          (video) => video.type === "Trailer" && video.site === "YouTube"
        );

        if (trailerVideo) {
          setTrailer(trailerVideo.key);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchMovie();
  }, [id]);
  if (!movie) {
    return <Loading />;
  }
  const saveToContinueWatching = (item) => {
    const existing = JSON.parse(localStorage.getItem("continueWatching")) || [];

    // إزالة العنصر إذا كان موجودًا مسبقًا
    const filtered = existing.filter(
      (movie) => !(movie.id === item.id && movie.mediaType === item.mediaType)
    );

    // إضافة العنصر الجديد في البداية
    const updated = [item, ...filtered].slice(0, 10);

    localStorage.setItem("continueWatching", JSON.stringify(updated));
  };
  return (
    <Main className="container">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Movie",
            name: movie?.title,
            description: movie?.overview,
            image: `https://image.tmdb.org/t/p/original${movie?.poster_path}`,
            datePublished: movie?.release_date,
          })}
        </script>
        <title>{movie?.title} | FlickDrive</title>

        <meta name="description" content={movie?.overview} />

        <meta property="og:title" content={movie?.title} />

        <meta property="og:description" content={movie?.overview} />

        <meta
          property="og:image"
          content={`https://image.tmdb.org/t/p/original${movie?.poster_path}`}
        />
      </Helmet>
      <div className="mt-5 pt-4 pb-4">
        <Link className="home-link" to="/">
          Home Page
        </Link>

        <span className="small-title">{movie.title}</span>
      </div>

      <div className="holder row">
        <img
          className="col-lg-8"
          src={`https://image.tmdb.org/t/p/original${movie.backdrop_path}`}
          alt={movie.title}
          loading="lazy"
        />

        <div className="col-lg-4">
          <h2 className="title">{movie.title}</h2>

          <div className="movie-info">
            <p>⭐ {movie.vote_average?.toFixed(1)}</p>

            <p>📅 {movie.release_date}</p>

            <p>⏱ {movie.runtime} min</p>

            <p>🎭 {movie.genres?.map((genre) => genre.name).join(", ")}</p>
          </div>

          <div className="desc-holder">
            <p className="desc">{movie.overview}</p>
          </div>
          {/* 
          {imdbId && (
            <button
              className="watch-btn"
              onClick={() => 
                window.open(
                  `https://streamimdb.ru/embed/movie/${imdbId}`,
                  "_blank"
                )
              }
            >
              Watch Now
            </button>
          )} */}
          {imdbId && (
            <button
              className="watch-btn"
              onClick={() => {
                saveToContinueWatching({
                  id: movie.id,
                  title: movie.title || movie.name,
                  poster: movie.poster_path,
                  backdrop: movie.backdrop_path,
                  mediaType: "movie", // أو "tv"
                  imdbId: imdbId,
                });

                window.open(
                  `https://streamimdb.ru/embed/movie/${imdbId}`,
                  "_blank"
                );
              }}
            >
              Watch Now
            </button>
          )}
        </div>
      </div>

      {trailer && (
        <div className="trailer-section">
          <h3>Trailer</h3>

          <iframe
            width="100%"
            height="500"
            src={`https://www.youtube.com/embed/${trailer}`}
            title="Trailer"
            allowFullScreen
          />
        </div>
      )}

      <div className="cast-section">
        <h3>Cast</h3>

        <div className="row">
          {cast.map((actor) => (
            <div
              key={actor.id}
              className="col-6 col-md-3 col-lg-2 text-center"
              onClick={() => navigate(`/actor-details/${actor.id}`)}
            >
              {actor.profile_path && (
                <img
                  src={`https://image.tmdb.org/t/p/w200${actor.profile_path}`}
                  alt={actor.name}
                  loading="lazy"
                />
              )}

              <p>{actor.name}</p>
            </div>
          ))}
        </div>
      </div>
      {/* <div className="recommendations">
        <h2>Recommended Movies</h2>

        <div className="recommendations-container">
          {recommendations.slice(0, 10).map((movie) => (
            <div
              className="recommendation-card"
              key={movie.id}
              onClick={() => navigate(`/movie/${movie.id}`)}
            >
              <img
                src={
                  movie.poster_path
                    ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
                    : "/no-image.png"
                }
                alt={movie.title}
              />

              <div className="recommendation-info">
                <h3>{movie.title}</h3>

                <p>⭐ {movie.vote_average?.toFixed(1)}</p>
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <Recommendations>
        <h2>Recommended Movies</h2>

        <div className="recommendations-container">
          {recommendations.slice(0, 10).map((movie) => (
            <div
              className="recommendation-card"
              key={movie.id}
              onClick={() => navigate(`/movie/${movie.id}`)}
            >
              <img
                src={
                  movie.poster_path
                    ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
                    : "/no-image.png"
                }
                alt={movie.title}
              />

              <div className="recommendation-info">
                <h3>{movie.title}</h3>

                <p>⭐ {movie.vote_average?.toFixed(1)}</p>
              </div>
            </div>
          ))}
        </div>
      </Recommendations>
    </Main>
  );
};

const Main = styled.div`
  min-height: 100vh;

  .home-link {
    color: #b89564;
    text-decoration: none;
  }

  .small-title {
    color: rgb(205 192 177);
    margin-left: 10px;
  }

  .holder img {
    width: 100%;
    border-radius: 20px;
  }

  .title {
    color: #b89564;
    margin-top: 15px;
  }

  .movie-info {
    color: white;
    margin-top: 20px;
  }

  .movie-info p {
    margin-bottom: 10px;
  }

  .desc-holder {
    margin-top: 20px;
  }

  .desc {
    color: rgb(205 192 177);
    line-height: 1.8;
  }

  .watch-btn {
    width: 100%;
    border: none;
    background: #b89564;
    color: white;
    padding: 10px;
    border-radius: 8px;
    margin-top: 20px;
    font-weight: bold;
    cursor: pointer;
  }

  .trailer-section {
    margin-top: 60px;
  }

  .trailer-section h3,
  .cast-section h3 {
    color: #b89564;
    margin-bottom: 20px;
  }

  .cast-section {
    margin-top: 60px;
  }

  .cast-section img {
    width: 100%;
    border-radius: 10px;
    margin-bottom: 10px;
  }

  .cast-section p {
    color: white;
    font-size: 14px;
  }
`;

const Recommendations = styled.div`
  margin-top: 60px;
  padding: 20px 0 50px;

  h2 {
    color: #fff;
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 30px;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      width: 70px;
      height: 3px;
      background: #b89564;
      left: 0;
      bottom: -8px;
      border-radius: 10px;
    }
  }

  .recommendations-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 20px;
  }

  .recommendation-card {
    cursor: pointer;
    border-radius: 10px;
    overflow: hidden;
    background: #181818;
    transition: 0.3s ease;
    position: relative;

    &:hover {
      transform: translateY(-8px);
      box-shadow: 0 15px 30px rgba(0, 0, 0, 0.5);
    }

    &:hover img {
      transform: scale(1.08);
    }
  }

  .recommendation-card img {
    width: 100%;
    height: 330px;
    object-fit: cover;
    display: block;
    transition: 0.4s ease;
  }

  .recommendation-info {
    padding: 12px 10px 15px;
  }

  .recommendation-info h3 {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    margin: 0 0 8px;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .recommendation-info p {
    color: #b89564;
    font-size: 14px;
    margin: 0;
  }

  @media (max-width: 1200px) {
    .recommendations-container {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (max-width: 992px) {
    .recommendations-container {
      grid-template-columns: repeat(3, 1fr);
    }

    .recommendation-card img {
      height: 350px;
    }
  }

  @media (max-width: 768px) {
    margin-top: 40px;

    h2 {
      font-size: 24px;
    }

    .recommendations-container {
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
    }

    .recommendation-card img {
      height: 300px;
    }
  }

  @media (max-width: 480px) {
    .recommendations-container {
      gap: 10px;
    }

    .recommendation-card img {
      height: 250px;
    }

    .recommendation-info h3 {
      font-size: 14px;
    }
  }
`;
export default MoviePage;
